import { render, staticRenderFns } from "./StatementDetails.vue?vue&type=template&id=305d2152&scoped=true"
import script from "./StatementDetails.vue?vue&type=script&lang=js"
export * from "./StatementDetails.vue?vue&type=script&lang=js"
import style0 from "./StatementDetails.vue?vue&type=style&index=0&id=305d2152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305d2152",
  null
  
)

export default component.exports